import request from '@/utils/http';

// 国家 参数为 pageSize&pageNo
export const getCountry = (params) => {
    return request({
        // url: `/api-mdm/searchEbPlacePage?ebplType=PLACE_COUNTRY&ebplIsAble=ENABLE`,
        url: `/api-mdm/searchEbPlace?ebplType=PLACE_COUNTRY&ebplIsAble=ENABLE&orderBy=ebplNameEn&orderByType=asc`,
        method: 'get',
        params: params
    });
};
// 省份 参数为 ebplParentPmCode
export const getProvince = (params) => {
    return request({
        // url: `/api-mdm/searchEbPlace?ebplType=PLACE_PROVINCE&ebplIsAble=ENABLE`,
        url: `/api-mdm/searchEbPlace?ebplType=PLACE_PROVINCE&ebplIsAble=ENABLE&orderBy=ebplNameEn&orderByType=asc`,
        method: 'get',
        params: params
    });
};

// 城市 参数为 ebplParentPmCode
export const getCity = (params) => {
    return request({
        // url: `/api-mdm/searchEbPlace?ebplType=PLACE_CITY&ebplIsAble=ENABLE`,
        url: `/api-mdm/searchEbPlace?ebplType=PLACE_CITY&ebplIsAble=ENABLE&orderBy=ebplNameEn&orderByType=asc`,
        method: 'get',
        params: params
    });
};

// 区 参数为 ebplParentPmCode
export const getDistrict = (params) => {
    return request({
        // url: `/api-mdm/searchEbPlace?ebplType=PLACE_DISTRICT&ebplIsAble=ENABLE`,
        url: `/api-mdm/searchEbPlace?ebplType=PLACE_DISTRICT&ebplIsAble=ENABLE&orderBy=ebplNameEn&orderByType=asc`,
        method: 'get',
        params: params
    });
};

// 镇街 参数为 ebplParentPmCode
export const getStreet = (params) => {
    return request({
        // url: `/api-mdm/searchEbPlace?ebplType=PLACE_STREET&ebplIsAble=ENABLE`,
        url: `/api-mdm/searchEbPlace?ebplType=PLACE_STREET&ebplIsAble=ENABLE&orderBy=ebplNameEn&orderByType=asc`,
        method: 'get',
        params: params
    });
};

// 根据上级地点parentPmCode查询集合
export const searchPlaces = (params) => {
    return request({
        url: `/api-dc/places`,
        method: 'get',
        params
    });
};
